import { useLocation } from "react-router";

/**
 * Utility function to determine if the current window is inside an iframe.
 */
export const getIsInIframe = () => {
  return typeof window !== "undefined" && window.self !== window.top;
};

export const getIsInDfrCommand = () => {
  const isInIframe = getIsInIframe();
  if (!isInIframe) {
    return false;
  }

  const { search } = window.location;
  const isInDfrCommand = new URLSearchParams(search).get("dfr") === "true";

  return isInDfrCommand;
};

type HiddenFromIframeProps = {
  children: React.ReactNode;
};

/**
 * HOC that hides its children if the current window is inside an iframe.
 * Primarily used for conditionally rendering portions of RFD when embedding
 * in DFR Command through an iframe.
 */
export const HiddenFromIframe = ({ children }: HiddenFromIframeProps) => {
  const isInIframe = getIsInIframe();

  if (isInIframe) {
    return null;
  }

  return children;
};

export const HiddenFromDfrCommand = ({ children }: HiddenFromIframeProps) => {
  const isInIframe = getIsInIframe();

  const { search } = useLocation();
  const isDfrCommand = new URLSearchParams(search).get("dfr") === "true";

  if (isInIframe && isDfrCommand) {
    return null;
  }

  return children;
};
